import React, { useState } from "react";
import InvoiceDate from "./Main";

const DEFAULT_VALUE = {
  value: null,
  // value: "02/10/2024",
}

const Demo = () => {
  const [value, setValue] = useState({...DEFAULT_VALUE})

  return (
    <>
      <InvoiceDate
        default_value={"02/10/2024"}
        value={value}
        onChange={(val) => setValue(val)}
      />
      <br/>
      Date: {value?.value}
    </>
  )
}

export default Demo;
